<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scrollTo'
export default {
  watch: {
    $route() {
      scrollTo(0, 500)
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
#app {
  background: #F5F8FC;
}
</style>



// WEBPACK FOOTER //
// src/App.vue